// import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Card, CardMedia, Stack, Typography } from "@mui/material";
import cardData from "../cardData";
import CardSlider from "./Slider";

// const loopedCardData = [...cardData, ...cardData];

const CardSliderPage = () => {

   return (
    <Box
      sx={{
        display: { xs: "flex", sm: "none" },
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <CardSlider cardData={cardData} />
    </Box>
  );

  };

export default CardSliderPage;

